import moment from 'moment';
import { Story, StoryType } from './types';

export interface StoryDataGridFormat {
  id: string;
  thumbnailUrl?: string;
  createdAt: string;
  caption: string;
  type: StoryType;
  category: string;
  shown: boolean;
  reactions: boolean;
  comments: boolean;
  story: Story;
}

export const convertFirestoreStoryToDatagridFormat = (story: Story): StoryDataGridFormat => {
  return {
    id: story.id,
    createdAt: moment(story.createdAt).format('YYYY-MM-DD HH:mm'),
    caption: story.caption,
    type: story.type,
    category: story.category,
    shown: story.hidden === undefined ? true : !story.hidden,
    reactions: story.disableReactions === undefined ? true : !story.disableReactions,
    comments: story.disableComments === undefined ? false : !story.disableComments,
    story,
  };
};
